import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, Icon, useTheme } from '@mui/material';
import WaterDropIcon from '@mui/icons-material/WaterDrop';
import InsightsIcon from '@mui/icons-material/Insights';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import ElectricalServicesIcon from '@mui/icons-material/ElectricalServices';

const features = [
  {
    title: 'Suministro Constante',
    description: 'Infraestructura monitoreada en tiempo real para garantizar un flujo ininterrumpido a cada hogar.',
    icon: <WaterDropIcon />,
    color: '#00695C'
  },
  {
    title: 'Analitica de Consumo',
    description: 'Accede a métricas detalladas y reportes históricos de tu consumo desde cualquier dispositivo.',
    icon: <InsightsIcon />,
    color: '#00e676'
  },
  {
    title: 'Transparencia Total',
    description: 'Gestión administrativa digitalizada para una rendición de cuentas clara y procesos audibles.',
    icon: <VerifiedUserIcon />,
    color: '#ff9800'
  },
  {
    title: 'Soporte 24/7',
    description: 'Atención especializada para reportes y mantenimiento, asegurando la calidad del recurso.',
    icon: <ElectricalServicesIcon />,
    color: '#e91e63'
  }
];

const LandingFeatures = () => {
  const theme = useTheme();

  return (
    <Box id="features" sx={{ py: 12, bgcolor: '#fbfcfd' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography
            variant="overline"
            sx={{ fontWeight: 800, color: 'primary.main', letterSpacing: 2 }}
          >
            NUESTROS SERVICIOS
          </Typography>
          <Typography
            variant="h3"
            sx={{ fontWeight: 900, mt: 1, color: '#001a33' }}
          >
            Tecnología al Servicio de la Vida
          </Typography>
          <Box
            sx={{
              width: '80px',
              height: '4px',
              bgcolor: 'primary.main',
              mx: 'auto',
              mt: 2,
              borderRadius: '2px'
            }}
          />
        </Box>

        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid key={index}>
              <Card
                sx={{
                  height: '100%',
                  borderRadius: '24px',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  border: '1px solid rgba(0,0,0,0.05)',
                  '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0 20px 40px rgba(0,0,0,0.08)',
                    borderColor: feature.color,
                    '& .icon-box': {
                      bgcolor: feature.color,
                      color: 'white',
                      transform: 'scale(1.1) rotate(5deg)'
                    }
                  }
                }}
              >
                <CardContent sx={{ p: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                  <Box
                    className="icon-box"
                    sx={{
                      width: '70px',
                      height: '70px',
                      borderRadius: '20px',
                      bgcolor: 'rgba(0,0,0,0.03)',
                      color: feature.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      mb: 3,
                      transition: 'all 0.4s ease'
                    }}
                  >
                    {React.cloneElement(feature.icon, { sx: { fontSize: 35 } })}
                  </Box>
                  <Typography variant="h6" sx={{ fontWeight: 800, mb: 2, color: '#001a33' }}>
                    {feature.title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary', lineHeight: 1.7 }}>
                    {feature.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default LandingFeatures;
